// -----------Importar Componentes de Terceros---------------------
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';

import Sets_funerarios_info from '../../assets/Imagenes/Sets/Sets_funerarios_info.png'

import TarjetaBeneficios from '../TarjetaBeneficios';


import './styles.css'

const ListTarjetas =
    [
        {
            TituloContenido: <p className='AlbertBold' >Asesoría personalizada<br />24/7 en Toluca</p>,
            ParrafoContenido: 'Te acompañamos desde el primer momento, resolviendo tus dudas y guiándote paso a paso.',
            ColorTarjeta: '#D14081',
        },
        {
            TituloContenido: <p className='AlbertBold' >Traslado del<br /> ser querido</p>,
            ParrafoContenido: 'Nos encargamos del traslado, ya sea local o foráneo, de forma segura y respetuosa.',
            ColorTarjeta: '#D14081',
        },
        {
            TituloContenido: <p className='AlbertBold' >Trámites legales y <br />administrativos</p>,
            ParrafoContenido: 'Gestionamos los permisos, certificados y documentación necesaria para que no tengas que preocuparte por nada.',
            ColorTarjeta: '#D95729'
        },
        {
            TituloContenido: <p className='AlbertBold' >Servicio de<br /> velación</p>,
            ParrafoContenido: 'Contamos con cómodas y privadas salas de velación, con todos los servicios que tú y tu familia necesitan.',
            ColorTarjeta: '#D95729',
        },
        {
            TituloContenido: <p className='AlbertBold' >Ataúd o <br />urna</p>,
            ParrafoContenido: 'Ofrecemos una variedad de opciones, adaptadas a tus necesidades y creencias.',
            ColorTarjeta: '#024C3C',
        },
        {
            TituloContenido: <p className='AlbertBold' >Cremación o<br /> inhumación</p>,
            ParrafoContenido: 'Ya sea que elijas sepultura tradicional o cremación, nosotros nos ocupamos de todo con el mayor respeto.',
            ColorTarjeta: '#024C3C',
        }
    ]


const ListTarjetasMovil =
    [
        {
            TituloContenido: <p className='AlbertBold' >Asesoría personalizada<br />24/7 en Toluca</p>,
            ParrafoContenido: 'Te acompañamos desde el primer momento, resolviendo tus dudas y guiándote paso a paso.',
            ColorTarjeta: '#D14081',
        },

        {
            TituloContenido: <p className='AlbertBold' >Trámites legales y <br />administrativos</p>,
            ParrafoContenido: 'Gestionamos los permisos, certificados y documentación necesaria para que no tengas que preocuparte por nada.',
            ColorTarjeta: '#D95729'
        },

        {
            TituloContenido: <p className='AlbertBold' >Ataúd o <br />urna</p>,
            ParrafoContenido: 'Ofrecemos una variedad de opciones, adaptadas a tus necesidades y creencias.',
            ColorTarjeta: '#024C3C',
        },
        {
            TituloContenido: <p className='AlbertBold' >Traslado del<br /> ser querido</p>,
            ParrafoContenido: 'Nos encargamos del traslado, ya sea local o foráneo, de forma segura y respetuosa.',
            ColorTarjeta: '#D14081',
        },

        {
            TituloContenido: <p className='AlbertBold' >Servicio de<br /> velación</p>,
            ParrafoContenido: 'Contamos con cómodas y privadas salas de velación, con todos los servicios que tú y tu familia necesitan.',
            ColorTarjeta: '#D95729',
        },
        {
            TituloContenido: <p className='AlbertBold' >Cremación o<br /> inhumación</p>,
            ParrafoContenido: 'Ya sea que elijas sepultura tradicional o cremación, nosotros nos ocupamos de todo con el mayor respeto.',
            ColorTarjeta: '#024C3C',
        }
    ]



const SetsInformacion = ({ }) => {
    const esPantallaPequena = useMediaQuery('(max-width:576px)');
    const esPantallaMediana = useMediaQuery('(max-width:992px)');


    const height = esPantallaPequena ? '200px' : '241px';

    const listtart = esPantallaPequena ? ListTarjetasMovil : ListTarjetas;




    const Width = esPantallaPequena ? '100%' : '280px';
    return (
        <div>
            <section className="ContenedorSetsInformacion">
                <Container className='SubContenedorSetsInformacion'>
                    <div className="row">
                        <div className="col-md-12 text-left">
                            <Typography variant='h2' className="animate__animated animate__fadeIn animate__delay-1s  TituloSetsInformacion">
                                En Columba Funerales Toluca, estamos contigo cuando más lo necesitas                            
                            </Typography>

                            <Typography className='ParrafoSetsInformacion'>
                                Sabemos que perder a un ser querido es una de las experiencias más difíciles de la vida. En esos momentos, lo último que necesitas es preocuparte por trámites, decisiones complicadas o gestiones abrumadoras. Por eso, en Columba Funerales te ofrecemos un servicio completo, claro y humano, pensado para acompañarte con respeto, empatía y facilidad.
                            </Typography>
                        </div>
                        <div className="col-md-8 ">
                            <Typography variant='h2' className="animate__animated animate__fadeIn animate__delay-1s  TituloSetsInformacion2">
                                Nuestros servicios incluyen todo lo que necesitas para
                                despedir con dignidad a tu ser querido:
                            </Typography>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 text-center mt-2">
                            <img id='ImagenSetsInformacion' src={Sets_funerarios_info} alt='Sets_funerarios_info' />
                        </div>
                        <div className="col-lg-6  text-center mt-2 ">
                            <div className='row  ContenedorTrajetasSet'>
                                {
                                    listtart.map((item, index) => (
                                        <div key={index} className="col-sm-6 text-center SubContenedorTarjetasSet " style={{ display: 'flex', justifyContent: 'center' }}>
                                            <TarjetaBeneficios Height={height} Width={Width} ShowImagen={false} ColorTarjeta={item.ColorTarjeta} TituloContenido={item.TituloContenido} ParrafoContenido={item.ParrafoContenido} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </div>
    );
}


export default SetsInformacion